import { useLogoutMutation } from 'src/api/auth';
import { useGetMe } from 'src/api/user';
import { type IconType } from 'src/components/Icon';

type MenuItem = {
  label: string;
  icon: IconType;
  action: () => void;
};
export const useUserMenu = () => {
  const { data: userData } = useGetMe();

  const { logoutMutation } = useLogoutMutation();

  const userName = `${userData?.first_name} ${userData?.last_name}`;

  const menuItems: MenuItem[] = [
    {
      action: () => console.log('settings'),
      icon: 'settings',
      label: 'Settings',
    },
    {
      action: () => console.log('tutorial'),
      icon: 'tutorial',
      label: 'Tutorial Mode',
    },
    {
      action: () => console.log('help'),
      icon: 'help',
      label: 'Help Centre',
    },
    {
      action: () => console.log('activity-log'),
      icon: 'activityLog',
      label: 'Activity Log',
    },
    {
      action: () => logoutMutation(),
      icon: 'logout',
      label: 'Sign Out',
    },
  ];

  return { menuItems, userName };
};
